import {
    apiRequest,
    kriteriaSkpTunsusList,
    kriteriaSkpTunsusActive,
    kriteriaSkpTunsusInactive
} from "../../../../../services/adapters/kepegawaian/kriteriaSkpTunsusService"

class DataTableRepository {

    fetchRowTable = async (query, cancelToken) => {
        return await apiRequest("get", kriteriaSkpTunsusList, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

    fetchInactive = async (query) => {
        return await apiRequest("post", kriteriaSkpTunsusInactive, {
            body: query
        }, true)
    }

    fetchActive = async (query) => {
        return await apiRequest("post", kriteriaSkpTunsusActive, {
            body: query
        }, true)
    }
}

export default DataTableRepository